import { render, staticRenderFns } from "./ResourcesInternalFolder.vue?vue&type=template&id=d50ae14c&scoped=true&"
import script from "./ResourcesInternalFolder.vue?vue&type=script&lang=js&"
export * from "./ResourcesInternalFolder.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesInternalFolder.vue?vue&type=style&index=0&id=d50ae14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50ae14c",
  null
  
)

export default component.exports